import React from 'react';
import styles from './styles.module.scss';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';

const PopUpCard = ({ popUp }) => {
  const history = useHistory();

  return (
    <div className={styles.wrapper}>
      <div className={styles.bodyCard}>
        <div className={styles.title}>Nome</div>
        <div className={styles.info}>{popUp.nome || 'SEM NOME'}</div>
        <div className={styles.title}>Período</div>
        <div className={styles.info}>
          {popUp.dataInicio === null
            ? 'Indeterminado'
            : `De ${new moment(popUp.dataInicio).format(
                'DD/MM/YYYY'
              )} Até ${new moment(popUp.dataFim).format('DD/MM/YYYY')}`}
        </div>
      </div>

      <div className={styles.actionWrapper}>
        <div
          className={
            styles[
              `${
                (popUp.popUpStatusId ==
                  '3055f433-945d-41fd-9b34-db303c5d34f9' &&
                  'ativo') ||
                (popUp.popUpStatusId ==
                  '9205f84f-ea81-486d-a607-237b14aa6ee1' &&
                  'encerrado') ||
                (popUp.popUpStatusId ==
                  '07f03f14-05b4-4734-a0a0-be8716453c39' &&
                  'rascunho')
              }`
            ]
          }
        >
          <div>
            {popUp.popUpStatusId == '3055f433-945d-41fd-9b34-db303c5d34f9'
              ? 'ATIVO'
              : null}
          </div>
          <div>
            {popUp.popUpStatusId == '9205f84f-ea81-486d-a607-237b14aa6ee1'
              ? 'ENCERRADO'
              : null}
          </div>
          <div>
            {popUp.popUpStatusId == '07f03f14-05b4-4734-a0a0-be8716453c39'
              ? 'RASCUNHO'
              : null}
          </div>
        </div>

        <button
          className={styles.editar}
          onClick={() => {
            history.push(`/pop-up/detalhe?PopUpId=${popUp.popUpId}`);
          }}
        >
          Editar
          <FontAwesomeIcon icon={faEdit} className={styles.icon} />
        </button>
      </div>
    </div>
  );
};

export default PopUpCard;
